import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CredentialsHelper = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const mockCredentials = [
    {
      role: 'Administrador',
      email: 'admin@finet.com',
      password: 'admin123',
      description: 'Acesso total ao sistema com todas as permissões'
    },
    {
      role: 'Coordenador',
      email: 'coordinator@finet.com',
      password: 'coord456',
      description: 'Coordenação regional e gestão de membros'
    },
    {
      role: 'Colaborador',
      email: 'staff@finet.com',
      password: 'staff789',
      description: 'Cadastro básico de membros e entrada de dados'
    }
  ];

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="mt-6 p-4 bg-muted/30 rounded-lg border border-border">
      <Button
        variant="ghost"
        onClick={toggleExpanded}
        className="w-full justify-between p-0 h-auto text-sm"
      >
        <span className="flex items-center">
          <Icon name="Info" size={16} className="mr-2" />
          Credenciais de demonstração
        </span>
        <Icon 
          name={isExpanded ? "ChevronUp" : "ChevronDown"} 
          size={16} 
        />
      </Button>
      {isExpanded && (
        <div className="mt-4 space-y-3">
          <p className="text-xs text-muted-foreground">
            Use estas credenciais para testar perfis de usuário:
          </p>
          {mockCredentials?.map((cred, index) => (
            <div
              key={index}
              className="p-3 bg-card rounded-md border border-border"
            >
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-sm font-medium text-foreground">
                  {cred?.role}
                </h4>
                <Icon name="User" size={16} className="text-muted-foreground" />
              </div>
              <div className="space-y-1 text-xs">
                <div className="flex items-center">
                  <span className="text-muted-foreground w-12">E-mail:</span>
                  <span className="text-foreground font-mono">{cred?.email}</span>
                </div>
                <div className="flex items-center">
                  <span className="text-muted-foreground w-12">Senha:</span>
                  <span className="text-foreground font-mono">{cred?.password}</span>
                </div>
                <p className="text-muted-foreground mt-1">{cred?.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CredentialsHelper;